import React from 'react';
import { CheckCircle2, Circle, Loader2 } from 'lucide-react';

const SOURCE = {
  runner: ['Workflow Runner', 'bg-emerald-50 text-emerald-700 border-emerald-200'],
  crm: ['CRM proved', 'bg-sky-50 text-sky-700 border-sky-200'],
  manual: ['OK\'d by hand', 'bg-amber-50 text-amber-800 border-amber-200'],
};

const when = (iso) => (iso ? new Date(iso).toLocaleString('en-NZ', { dateStyle: 'medium', timeStyle: 'short' }) : '');

export const StatusTaskRow = ({ task, busy, onTick, canTick }) => {
  const [label, cls] = SOURCE[task.source] || [];
  const detail = task.source === 'manual' ? `${task.by} · ${when(task.at)}` : task.evidence;
  return (
    <li className="flex items-center gap-3 py-2 border-b border-slate-100 last:border-0" data-testid={`status-task-${task.id}`}>
      {task.done ? <CheckCircle2 size={16} className="text-emerald-600 flex-shrink-0" /> : <Circle size={16} className="text-slate-300 flex-shrink-0" />}
      <div className="flex-1 min-w-0">
        <div className={`text-sm ${task.done ? 'text-slate-800' : 'text-slate-500'}`}>{task.label}</div>
        {detail && <div className="text-[11px] text-slate-400 truncate" data-testid={`status-task-detail-${task.id}`}>{detail}</div>}
      </div>
      {label && <span className={`text-[10px] font-semibold px-2 py-0.5 rounded border ${cls}`} data-testid={`status-task-source-${task.id}`}>{label}</span>}
      {canTick && !task.done && (
        <button data-testid={`status-task-ok-${task.id}`} disabled={busy} onClick={() => onTick(task, true)}
          className="text-[11px] font-semibold px-2.5 py-1 rounded-md border border-[#0F4F1B] text-[#0F4F1B] hover:bg-[#0F4F1B] hover:text-white transition-colors disabled:opacity-50">
          {busy ? <Loader2 size={11} className="animate-spin" /> : 'OK this step'}
        </button>
      )}
      {task.source === 'manual' && (
        <button data-testid={`status-task-undo-${task.id}`} disabled={busy} onClick={() => onTick(task, false)}
          className="text-[11px] px-2 py-1 rounded-md text-slate-500 hover:text-rose-600 hover:underline disabled:opacity-50">Undo</button>
      )}
    </li>
  );
};
